import React from 'react'
import HideInputProvider from '../../contextHook/hideInput'

const withProvider = Component => {
  const WrappedComponent = props => {
    return (
      <HideInputProvider>
        <Component {...props} />
      </HideInputProvider>
    )
  }
  return WrappedComponent
}

export default withProvider
